import { get as lodashGet, noop as lodahsNoop } from 'lodash'
import { Api } from '@/api'

/*
*   Promise API
*   @data {
*       endpoint: { String, [String] },
*       params: {},
*       transform: () => {},
*       paginator: () => {},
*   }
*   @return Promise
*/

export default function ({
    endpoint, params, transform = lodahsNoop, paginator = lodahsNoop,
}) {
    // Clean params
    const parameters = (Array.isArray(params) ? params : [params]).map((p) => {
        if (typeof p === 'object') {
            // remove "empty" keys
            return Object.entries(p).reduce((acc, [key, value]) => (value !== undefined ? { ...acc, [key]: value } : acc), {})
        }
        return p
    })

    // Array endpoints
    if (Array.isArray(endpoint)) {
        const promises = endpoint.map(ep => lodashGet(Api(), ep)).filter(p => !!p)
        return Promise.all(promises.map((p, index) => p(...[parameters[index]]))).then((results) => {
            if (Array.isArray(results) && !results.find(result => !result || result.ok !== true)) {
                const datas = results.map(r => r.data)
                return Promise.resolve({
                    ok: true,
                    rawData: datas,
                    data: transform(datas),
                })
            }
            return Promise.reject(results)
        })
    }

    // Unique endpoint
    const promise = lodashGet(Api(), endpoint)
    if (promise) {
        return promise(...parameters).then((result) => {
            if (result && result.ok === true) {
                return Promise.resolve({
                    ...result,
                    rawData: result.data,
                    data: transform(result.data),
                    pagination: paginator(result.data),
                })
            }
            return Promise.reject(result)
        })
    }
    console.warn(`PromiseApi: endpoint "${endpoint}" does not exist`)
    return Promise.reject(new Error(`Endpoint "${endpoint}" does not exist`))
}
